module.exports = __webpack_public_path__ + "static/img/hulianwangdahui.ee9caf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/hulianwangdahui.jpg
// module id = dH3y
// module chunks = 1